import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import validationUtils from "../../../../../../utils/ValidationUtils";
import { EnumWrapper } from "../../../../../../utils/enums";
import { LANGUAGE_CODES } from "../../../../../../utils/enums/enums";
import { SelectInput, TextInput } from "../../../../../common/form";
import { OPERATIONAL_CONTACT_VALIDATION_RULES } from "./operationalContactsValidationRules";
import PhoneNumberInput from "../../../../../common/form/PhoneNumberInput";
import { convertBlankOptionToNull } from "../../premiumSimulator/utils";

class OperationalContactFields extends React.Component {
    constructor(props, context) {
        super(props, context);
    }


    render() {
        const {
            handleSubmit,
            externalRole,
            accountManager,
            serviceRepresentative,
            users,
            submitting,
            disabled
        } = this.props;
        const disabledInternalContacts = (externalRole || this.props.disabledInternalContacts || disabled)
        return (
            <form onSubmit={handleSubmit}>
                <h3>
                    <FormattedMessage id="clientContacts.form.operationalContact.title" />
                </h3>
                <div className="client-contact">
                    <div>
                        <h4>
                            <FormattedMessage id="clientContacts.form.operationalContact.internalContacts" />
                        </h4>
                        <Field
                            id="accountManagerId"
                            name="accountManagerId"
                            component={SelectInput}
                            addBlankOption={true}
                            options={externalRole ? accountManager : users}
                            disabled={disabledInternalContacts}
                            label={<FormattedMessage id="clientContacts.form.operationalContact.accountManager" />}
                        />
                        <Field
                            id="serviceRepresentativeId"
                            name="serviceRepresentativeId"
                            component={SelectInput}
                            addBlankOption={true}
                            normalize={(value) => convertBlankOptionToNull(value)}
                            blankMessageKey="common.blank"
                            options={externalRole ? serviceRepresentative : users}
                            disabled={disabledInternalContacts}
                            label={
                                <FormattedMessage id="clientContacts.form.operationalContact.serviceRepresentative" />
                            }
                        />
                    </div>
                    <div>
                        <h4>
                            <FormattedMessage id="clientContacts.form.operationalContact.mainTitle" />
                        </h4>

                        <Field
                            id="contactFirstName"
                            name="contactFirstName"
                            type="text"
                            component={TextInput}
                            label={<FormattedMessage id="clientContacts.form.operationalContact.firstName" />}
                            disabled={disabled}
                        />

                        <Field
                            id="contactLastName"
                            name="contactLastName"
                            type="text"
                            component={TextInput}
                            label={<FormattedMessage id="clientContacts.form.operationalContact.lastName" />}
                            disabled={disabled}
                        />

                        <Field
                            id="contactJobPosition"
                            name="contactJobPosition"
                            type="text"
                            component={TextInput}
                            label={<FormattedMessage id="clientContacts.form.operationalContact.contactTitle" />}
                            disabled={disabled}
                        />

                        <PhoneNumberInput
                            fieldId="contactPhoneNumber"
                            fieldName="contactPhoneNumber"
                            labelTranslationString="clientContacts.form.operationalContact.phoneNumber"
                            forcedValidationErrorKey="clientContacts.form.operationalContact.phoneNumberFormatError"
                            formName="operationalContactFields"
                            disabled={disabled}
                            initialPhoneNumber={
                                this.props.initialValues ? this.props.initialValues.contactPhoneNumber : ""
                            }
                        />
                        <Field
                            id="contactPhoneNumberExtension"
                            name="contactPhoneNumberExtension"
                            type="text"
                            component={TextInput}
                            label={<FormattedMessage id="clientContacts.form.operationalContact.extensionNumber" />}
                            disabled={disabled}
                        />

                        <Field
                            id="contactEmailAddress"
                            name="contactEmailAddress"
                            type="text"
                            component={TextInput}
                            label={<FormattedMessage id="clientContacts.form.operationalContact.emailAddress" />}
                            disabled={disabled}
                        />

                        <EnumWrapper enum={LANGUAGE_CODES} format="inputs" prop="options">
                            <Field
                                id="contactLanguageCode"
                                name="contactLanguageCode"
                                component={SelectInput}
                                disabled={disabled}
                                addBlankOption={true}
                                label={<FormattedMessage id="clientContacts.form.operationalContact.language" />}
                            />
                        </EnumWrapper>
                    </div>
                    <div>
                        <h4>
                            <FormattedMessage id="clientContacts.form.operationalContact.adminTitle" />
                        </h4>

                        <Field
                            id="adminContactFirstName"
                            name="adminContactFirstName"
                            type="text"
                            component={TextInput}
                            label={<FormattedMessage id="clientContacts.form.operationalContact.firstName" />}
                            disabled={disabled}
                        />
                        <Field
                            id="adminContactLastName"
                            name="adminContactLastName"
                            type="text"
                            component={TextInput}
                            label={<FormattedMessage id="clientContacts.form.operationalContact.lastName" />}
                            disabled={disabled}
                        />

                        <Field
                            id="adminContactJobPosition"
                            name="adminContactJobPosition"
                            type="text"
                            component={TextInput}
                            label={<FormattedMessage id="clientContacts.form.operationalContact.contactTitle" />}
                            disabled={disabled}
                        />

                        <PhoneNumberInput
                            fieldId="adminContactPhoneNumber"
                            fieldName="adminContactPhoneNumber"
                            labelTranslationString="clientContacts.form.operationalContact.phoneNumber"
                            forcedValidationErrorKey="clientContacts.form.operationalContact.phoneNumberFormatError"
                            formName="operationalContactFields"
                            disabled={disabled}
                            initialPhoneNumber={
                                this.props.initialValues ? this.props.initialValues.adminContactPhoneNumber : ""
                            }
                        />
                        <Field
                            id="adminContactPhoneNumberExtension"
                            name="adminContactPhoneNumberExtension"
                            type="text"
                            component={TextInput}
                            label={<FormattedMessage id="clientContacts.form.operationalContact.extensionNumber" />}
                            disabled={disabled}
                        />
                        <Field
                            id="adminContactEmailAddress"
                            name="adminContactEmailAddress"
                            type="text"
                            component={TextInput}
                            label={<FormattedMessage id="clientContacts.form.operationalContact.emailAddress" />}
                            disabled={disabled}
                        />

                        <EnumWrapper enum={LANGUAGE_CODES} format="inputs" prop="options">
                            <Field
                                id="adminContactLanguageCode"
                                name="adminContactLanguageCode"
                                component={SelectInput}
                                disabled={disabled}
                                addBlankOption={true}
                                label={<FormattedMessage id="clientContacts.form.operationalContact.language" />}
                            />
                        </EnumWrapper>
                    </div>
                </div>
                <div className="operational-button-container">
                    <button disabled={submitting || disabled} type="submit" className="btn btn-lg btn-primary">
                        <FormattedMessage id="clientContacts.form.operationalContact.save" />
                    </button>
                </div>
            </form>
        );
    }
}

OperationalContactFields.propTypes = {
    client: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func,
    initialValues: PropTypes.object,
    externalRole: PropTypes.bool,
    serviceRepresentative: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    accountManager: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    users: PropTypes.array,
    submitting: PropTypes.bool,
    disabled: PropTypes.bool,
    disabledInternalContacts: PropTypes.bool,
};

export default connect(null, null, null, {
    withRef: true,
})(
    reduxForm({
        form: "operationalContactFields",
        validate: (values) => validationUtils.validate(values, OPERATIONAL_CONTACT_VALIDATION_RULES),
    })(OperationalContactFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/contacts/operational-contacts/OperationalContactFields.js